import React from "react"
import { FaArrowLeft, FaArrowRight } from "react-icons/fa"
import { AiOutlineClose } from "react-icons/ai"
import { GatsbyImage } from "gatsby-plugin-image"
export default function Model({ setAction, image, title, active, setActive }) {
  return (
    <section className="fixed h-screen overflow-hidden top-0 left-0 z-[55] w-full bg-stone-800/80 flex items-center justify-center">
      <div className="w-11/12 mx-auto aspect-square lg:aspect-video bg-black rounded grid items-end relative">
        <button
          onClick={() => setAction(false)}
          className="absolute z-50 -right-4 -top-4 text-white bg-teal-600 shadow-lg shadow-teal-600/50 rounded p-2"
        >
          <AiOutlineClose className="text-3xl" />
        </button>
        <div className="col-start-1 row-start-1 relative z-0 shadow-xl shadow-stone-900/30">
          <GatsbyImage
            image={image[active].asset.gatsbyImageData}
            className="aspect-square lg:aspect-video w-full object-cover"
            alt={title}
          />
        </div>
        <div className="col-start-1 row-start-1 relative z-10">
          <div>
            <div className="flex justify-end space-x-3 max-w-6xl mx-auto w-11/12 xl:w-full relative -top-5 z-50">
              <button
                disabled={active <= 0 ? true : false}
                onClick={() => setActive(active => active - 1)}
                className={` text-white rounded shadow-lg shadow-teal-600/50  p-3 ${
                  active <= 0
                    ? "bg-stone-800 cursor-not-allowed"
                    : "bg-teal-600"
                }`}
              >
                <FaArrowLeft />
              </button>
              <button
                disabled={active >= image.length - 1 ? true : false}
                onClick={() => setActive(active => active + 1)}
                className={` shadow-lg rounded shadow-teal-600/50 text-white p-3 ${
                  active >= image.length - 1
                    ? "bg-stone-800 cursor-not-allowed"
                    : "bg-teal-600"
                }`}
              >
                <FaArrowRight />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
